import { Dispatch } from 'redux'

import { IAuthRegister, IAuthLogin, IAuthLoginError, IAuthForgotPassword, IAuthForgotPasswordError, IAuthUserCurrent, AuthRoles } from '../../models'
import { authConstants } from '../constants'
import { authService } from '../../services'

const login = (data: IAuthLogin, role: AuthRoles = '') => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(request())
    const resp: any = await authService.login(data, role)

    if(resp && resp.status === 'Ok') {
      const {patient, token} = resp.data

      authService.setUserCurrentStorage({
        info: patient,
        token
      })

      dispatch(success(resp.data))
    } else if (resp && resp.code === 3) {
        dispatch(failure(resp.msg))
    } else {
      dispatch(failure(resp && resp.error? resp.error : {}))
    }

  } catch(error: any) {
    dispatch(failure(error))
  }

  function request() {
    return {
      type: authConstants.LOGIN_REQUEST
    }
  }

  function success(patient: IAuthRegister) {
    return {
      type: authConstants.LOGIN_SUCCESS,
      patient
    }
  }

  function failure(error: IAuthLoginError[]) {
    return {
      type: authConstants.LOGIN_FAILURE,
      error
    }
  }
}

const logout = (userId: string) => {
  authService.logout(userId)

  return {
    type: authConstants.GET_USER_CURRENT_STORAGE,
    currentUser: null
  }
}

const forgotPassword = (data: IAuthForgotPassword) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(request())
    const resp: any = await authService.forgetPassword(data)

    if(resp && resp.status === 'Ok') {
      dispatch(success(resp.data))
    } else {
      dispatch(failure(resp && resp.error? resp.error : {}))
    }

  } catch(error: any) {
    dispatch(failure(error))
  }

  function request() {
    return {
      type: authConstants.FORGOTPASSWORD_REQUEST
    }
  }

  function success(patient: IAuthForgotPassword) {
    return {
      type: authConstants.FORGOTPASSWORD_SUCCESS,
      patient
    }
  }

  function failure(error: IAuthForgotPasswordError[]) {
    return {
      type: authConstants.FORGOTPASSWORD_FAILURE,
      error
    }
  }
}

const updateUserCurrentStorage = (userData: any) => {
  const currentUser: IAuthUserCurrent = authService.getUserCurrentStorage()

  authService.setUserCurrentStorage({
    info: userData,
    token: currentUser.token
  })

  return getUserCurrentStorage()
}

const getUserCurrentStorage = () => {
  const currentUser: IAuthUserCurrent = authService.getUserCurrentStorage()

  return {
    type: authConstants.GET_USER_CURRENT_STORAGE,
    currentUser
  }
}

export const authActions = {
  login,
  logout,
  forgotPassword,
  updateUserCurrentStorage,
  getUserCurrentStorage
}